import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDgmOYTei1l7uwQKphehWZpufUmIuLstFU",
  authDomain: "sinifdefterimyeni.firebaseapp.com",
  projectId: "sinifdefterimyeni",
  storageBucket: "sinifdefterimyeni.firebasestorage.app",
  messagingSenderId: "304369639733",
  appId: "1:304369639733:web:9d1bdf5a0d9d0ceca46c7c",
  measurementId: "G-ZBCMC1T9R4"
}; 

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);